import React, { useState } from "react";
import { Box, Button, InputLabel, Stack, TextField, Switch } from "@mui/material";
import { Partnership } from "../../Models/Partnership";
import { addOrUpdatePartnership } from "../../Requests/PartnershipService";
import AvatarDropzone from "../StyledComponents/AvatarDropzone/AvatarDropzone";
import ImageDropzone from "../StyledComponents/AvatarDropzone/ImageDropzone.tsx";
import HtmlEditor from '../HtmlEditorView/HtmlEditor.jsx';


export default function AddPartnership(props) {

  const [logoImage, setLogoImage] = useState()
  const [heroImage, setHeroImage] = useState()
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [shortDescription, setShortDescription] = useState("")
  const [makePublic, setMakePublic] = useState(true)
  const [sortingPosition, setSortingPosition] = useState("99")

  const handlePublish = async () => {
    let object = new Partnership()
    object.title = title
    object.description = description
    object.hidden = !makePublic
    object.shortDescription = shortDescription
    object.sortingPosition = Partnership.normalizeSortingPosition(sortingPosition)
    await addOrUpdatePartnership(object, logoImage, heroImage)
    props.publish()
  }

  return (
    <>
      <Box>
        <AvatarDropzone
          title={"Logo Image"}
          callbackFile={(file) => { setLogoImage(file) }}
        />

        <ImageDropzone
          title={"Hero Image"}
          callbackFile={(file) => { setHeroImage(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Title"}</InputLabel>
          <TextField
            placeholder="Title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Organisation/Company"}</InputLabel>
          <TextField
            placeholder="Organisation/Company"
            value={shortDescription}
            onChange={(event) => setShortDescription(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Sorting position"}</InputLabel>
          <TextField
            type="number"
            placeholder="1-100"
            value={sortingPosition}
            onChange={(event) => {
              const next = event.target.value
              if (next === "") {
                setSortingPosition("")
                return
              }
              const normalized = Partnership.normalizeSortingPosition(next)
              setSortingPosition(String(normalized))
            }}
            inputProps={{ min: 1, max: 100, step: 1 }}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Description"}</InputLabel>
          <HtmlEditor initialValue={description} onChange={setDescription} />
        </Stack>

        <Box
          marginTop={2}
          marginBottom={1}
          width="100%"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <InputLabel sx={{ flex: 1, minWidth: 0, whiteSpace: "normal" }}>{"Make this partnership public"}</InputLabel>
          <Switch
            checked={makePublic}
            onChange={(e) => setMakePublic(e.target.checked)}
          />
        </Box>

      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </>
  )
}
